// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsArea/style.css
// module id = 3743
// module chunks = 33